module.exports = __webpack_public_path__ + "static/img/HAWTHORN.56c4d62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HAWTHORN.svg
// module id = tqzf
// module chunks = 0